@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <div class="flex flex-col gap-4">
    <h3 class="text-secondary text-sm font-semibold uppercase tracking-wide">{{ title }}</h3>

    @if (loading) {
      <div class="flex justify-center py-6"><mat-spinner diameter="28" color="primary" /></div>
    }

    @if (error && !loading) {
      <div class="py-3 text-center text-sm text-red-500">{{ error }}</div>
    }

    @if (data && !loading) {
      <!-- Top Attention Communities -->
      @if (data.top_attention_communities?.length > 0) {
        <div>
          <div class="mb-2 flex items-center gap-2">
            <mat-icon class="!text-sm text-orange-500">location_city</mat-icon>
            <span class="text-[11px] font-bold uppercase tracking-wider text-gray-400">Communities — Pending Service Requests</span>
            <div class="flex-1 border-t border-gray-100"></div>
            <span class="rounded-full px-1.5 py-0.5 text-[10px] font-semibold" [ngClass]="data.top_attention_communities_total ?? data.top_attention_communities.length | countBadge">{{
              data.top_attention_communities_total ?? data.top_attention_communities.length
            }}</span>
          </div>
          <div class="divide-y divide-gray-50">
            @for (c of data.top_attention_communities.slice(0, 5); track c.association_id) {
              <a class="flex items-center gap-2.5 py-2 transition-colors hover:bg-gray-50" routerLink="/eservices/list" [queryParams]="{ status: 'Pending', association_id: c.association_id }">
                <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-orange-50">
                  <mat-icon class="!text-sm text-orange-500">apartment</mat-icon>
                </div>
                <span class="min-w-0 flex-1 truncate text-xs font-medium text-gray-700" [matTooltip]="c.name">{{ c.name }}</span>
                <span class="shrink-0 rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-bold text-orange-700">{{ c.pending_count ?? c.open_count }} requests</span>
              </a>
            }
          </div>
        </div>
      }

      <!-- High-value overdue receivables -->
      @if (data.high_value_overdue_receivables?.length > 0) {
        <div>
          <div class="mb-2 flex items-center gap-2">
            <mat-icon class="!text-sm text-red-600">money_off</mat-icon>
            <span class="text-[11px] font-bold uppercase tracking-wider text-gray-400">High-Value Overdue</span>
            <div class="flex-1 border-t border-gray-100"></div>
            <span class="rounded-full px-1.5 py-0.5 text-[10px] font-semibold" [ngClass]="data.high_value_overdue_receivables_total ?? data.high_value_overdue_receivables.length | countBadge">{{
              data.high_value_overdue_receivables_total ?? data.high_value_overdue_receivables.length
            }}</span>
          </div>
          <div class="divide-y divide-gray-50">
            @for (inv of data.high_value_overdue_receivables.slice(0, 5); track inv.id) {
              <div class="flex items-center gap-2.5 py-2 transition-colors hover:bg-gray-50">
                <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-red-50">
                  <mat-icon class="!text-sm text-red-500">receipt_long</mat-icon>
                </div>
                <div class="min-w-0 flex-1">
                  <div class="text-xs font-medium text-gray-700">Invoice #{{ inv.id }}</div>
                  <div class="text-[10px] text-gray-400">Due {{ inv.due_date }}</div>
                </div>
                <span class="shrink-0 text-xs font-bold text-red-700"><app-currency-symbol></app-currency-symbol> {{ inv.amount | number: '1.0-0' }}</span>
              </div>
            }
          </div>
        </div>
      }

      @if (!data.top_attention_communities?.length && !data.high_value_overdue_receivables?.length) {
        <div class="flex flex-col items-center gap-1.5 rounded-lg border border-dashed border-gray-200 py-8 text-center">
          <mat-icon class="!text-3xl text-gray-300">check_circle</mat-icon>
          <span class="text-xs text-gray-400">No risks or escalations to report</span>
        </div>
      }
    }
  </div>
}
